import FullAudioPlayer from "./PlayerClient";
import { useParams } from "react-router-dom";

export default function PlayerPage() {
  const { reciterId = "", surahNumber = "1" } = useParams();
  return (
    <FullAudioPlayer
      reciterId={decodeURIComponent(reciterId)}
      surahNumber={Number(surahNumber)}
    />
  );
}
